import type { ExternalNetworkEntityKind } from '@terra/shared-contracts-external-network';
import {
  ENET_ASSET_LIST_KIND,
  type EnetAssetListKind,
} from '@terra/ui-design-system';

export {
  ENET_ASSET_LIST_COLUMN,
  ENET_ASSET_LIST_COLUMNS,
  ENET_ASSET_LIST_COLUMN_WIDTHS,
  ENET_ASSET_LIST_GRID_TEMPLATE,
  ENET_ASSET_LIST_KIND,
  ENET_ASSET_LIST_NAME_COLUMN_WIDTH,
  ENET_ASSET_LIST_ROW_MIN_WIDTH,
  enetAssetListGridTemplate,
  enetAssetListHasDetectionColumns,
  type EnetAssetListColumnId,
  type EnetAssetListKind,
} from '@terra/ui-design-system';

export const ENET_ASSET_LIST_NAME_KEY: Record<EnetAssetListKind, string> = {
  ALL: 'all',
  NETBLOCK: 'netblock',
  DOMAIN: 'domain',
  HOST: 'host',
  GATEWAY: 'gateway',
  NETWORK_SERVICE: 'service',
  SOFTWARE: 'software',
  STORAGE_SERVICE: 'storage',
};

export function enetAssetListKindFromFilter({
  selectedKind,
}: {
  selectedKind: ExternalNetworkEntityKind | null;
}): EnetAssetListKind {
  return selectedKind ?? ENET_ASSET_LIST_KIND.ALL;
}
